import { memo } from "react";

import { defaultToTrue } from "@Components/Modules/Helpers";

export default memo(
    (props: React.SVGProps<SVGSVGElement>) => (
        <svg {...props} viewBox="0 0 16 16" fill={props.color || "#dc2664"}>
            <path d="M8.35 10.88L5.26 3.63C4.3 1.41 3 .5 1.87.24A7.18 7.18 0 000 .19a3.45 3.45 0 011.62.49c.81.52 1.31 1.75 1.08 3.42l-1 7.24c-.14.89-.4 2.35-.4 2.35h1.44s.09-1.11.22-2.12l.93-7.06L7 11.92a4 4 0 001.44 2l3.69-9.42.93 7.92c.06.56.1 1.28.1 1.28H15s-.16-.95-.26-1.72L13.66 3.9c0-.38-.08-1-.08-1h-2.26a2.93 2.93 0 01-.24 1l-2.73 7z" />
        </svg>
    ),
    defaultToTrue,
);
